import { render, staticRenderFns } from "./CollectorOrderList.vue?vue&type=template&id=6c2dcebc&scoped=true&"
import script from "./CollectorOrderList.vue?vue&type=script&lang=js&"
export * from "./CollectorOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2dcebc",
  null
  
)

export default component.exports